export default __webpack_public_path__ + "static/media/princi1.8c10cd40.jpg";